import { type MediaInfo } from './typeAliases';

export const noop = (): void => {};

export const numberOfElements = (mediaList?: Array<MediaInfo>): number =>
    (mediaList || []).reduce(
        (prev, curr) => (curr.mediaLocation || curr.uploadPending ? prev + 1 : prev),
        0
    );

export function createRandomId(): string {
    return `${Date.now()}-${Math.random()}`;
}

export function getVariableAspectRatio(dimension: { width: number; height: number }): number {
    let aspect = dimension.width / dimension.height;
    if (aspect < 2 / 3) {
        aspect = 2 / 3;
    } else if (aspect > 3 / 2) {
        aspect = 3 / 2;
    }
    return aspect;
}

export function getZoomRange(
    initialDimensions: { width: number; height: number },
    imageReqs: { targetWidth: number; targetHeight: number },
    rotationFactor: number
): number {
    //calculate max zoom possible to meet min requirements
    const maxZoomWidth1 = initialDimensions.width / imageReqs.targetWidth;
    const maxZoomHeight1 = initialDimensions.height / imageReqs.targetHeight;
    const maxZoom1 = Math.min(maxZoomWidth1, maxZoomHeight1);
    if (rotationFactor === 90) {
        //calculate max zoom possible if rotated 90degrees
        const maxZoomWidth2 = initialDimensions.height / imageReqs.targetWidth;
        const maxZoomHeight2 = initialDimensions.width / imageReqs.targetHeight;
        const maxZoom2 = Math.min(maxZoomWidth2, maxZoomHeight2);
        return Math.min(maxZoom1, maxZoom2);
    }
    return maxZoom1;
}

export function getZoomCoordinatesFromUrl(imageUrl: string): {
    width: number;
    height: number;
    x: number;
    y: number;
} {
    const myUrl = new URL(imageUrl);
    const cropParams = myUrl.searchParams.get('crop');
    const initialCropArea = { width: 0, height: 0, x: 0, y: 0 };
    if (cropParams) {
        //crop search param is format "width, height, x value, y value"
        //ex: "260,78,x8,y12"
        const paramArray = cropParams.split(',');
        initialCropArea.width = parseInt(paramArray[0]);
        initialCropArea.height = parseInt(paramArray[1]);
        initialCropArea.x = parseInt(paramArray[2].substring(1));
        initialCropArea.y = parseInt(paramArray[3].substring(1));
    }
    return initialCropArea;
}

export function getRotationFromUrl(imageUrl: string): number {
    const myUrl = new URL(imageUrl);
    const rotateParam = myUrl.searchParams.get('orient');
    let rotation = 0;
    if (rotateParam === '6') {
        rotation = 90;
    } else if (rotateParam === '3') {
        rotation = 180;
    } else if (rotateParam === '8') {
        rotation = 270;
    }
    return rotation;
}

export function reformatCropArea(
    cropArea: { x: number; y: number; width: number; height: number },
    loadedMediaSize: {
        width: number;
        height: number;
        naturalWidth: number;
        naturalHeight: number;
    },
    rotation: number
): { x1: number; x2: number; y1: number; y2: number } {
    let newX = cropArea.x;
    let newY = cropArea.y;
    if (
        (rotation === 90 || rotation === 270) &&
        loadedMediaSize.naturalWidth !== loadedMediaSize.naturalHeight
    ) {
        const offset = Math.ceil(
            Math.abs(loadedMediaSize.naturalWidth - loadedMediaSize.naturalHeight) / 2
        );
        if (loadedMediaSize.naturalWidth < loadedMediaSize.naturalHeight) {
            newX += offset;
            newY -= offset;
        } else {
            newX -= offset;
            newY += offset;
        }

        //correct for rounding errors to ensure no negatives, coordinates within limits
        if (newX < 0) {
            newX = 0;
        } else if (newX + cropArea.width > loadedMediaSize.naturalHeight) {
            newX -= newX + cropArea.width - loadedMediaSize.naturalHeight;
        }
        if (newY < 0) {
            newY = 0;
        } else if (newY + cropArea.height > loadedMediaSize.naturalWidth) {
            newY -= newY + cropArea.height - loadedMediaSize.naturalWidth;
        }
    }
    return { x1: newX, x2: newX + cropArea.width, y1: newY, y2: newY + cropArea.height };
}
